import { SearchParams, SearchParamsConfig } from "../../../types/search-types";
import { Plugin } from "..";

class Bathrooms implements Plugin {
  async exec(
    segment: string,
    searchParams: SearchParams,
    _config: SearchParamsConfig,
  ): Promise<SearchParams> {
    if (searchParams.bathrooms) {
      return searchParams;
    }

    // Match patterns like "1-bathrooms", "1-and-2-bathrooms", "1-and-2-and-3-bathrooms" within larger strings
    const regex = /(?:^|-)(\d{1,2}(?:-and-\d{1,2}){0,9})-baths(?:$|-)/;
    const match = regex.exec(segment);

    if (match) {
      // Extract all numbers from the matched pattern using the captured group
      const bathroomNumbers = match[1].split("-and-");
      searchParams.bathrooms = bathroomNumbers;
    }

    return searchParams;
  }
}

export const bathrooms = new Bathrooms();
